// i18n strings for the Studio 3D "Diseño" tab — exclusive RE₿EL gallery (modal version).

const ES = {
  abrirGaleria: "🎨 Ver Diseños RE₿EL",
  tituloModal: "Diseños Exclusivos RE₿EL™",
  subModal: "Haz click en un diseño para aplicarlo a la prenda",
  cerrar: "✕ Cerrar",
  seleccionado: "✓ Diseño aplicado:",
  cambiar: "Cambiar diseño",
  quitar: "✕ Quitar",
  tuDiseno: "O sube tu propio diseño",
  countSuffix: "diseños exclusivos",
};

const EN = {
  abrirGaleria: "🎨 View RE₿EL Designs",
  tituloModal: "Exclusive RE₿EL™ Designs",
  subModal: "Click a design to apply it to the garment",
  cerrar: "✕ Close",
  seleccionado: "✓ Design applied:",
  cambiar: "Change design",
  quitar: "✕ Remove",
  tuDiseno: "Or upload your own design",
  countSuffix: "exclusive designs",
};

const SK = {
  abrirGaleria: "🎨 Zobraziť RE₿EL Dizajny",
  tituloModal: "Exkluzívne RE₿EL™ Dizajny",
  subModal: "Klikni na dizajn pre jeho aplikáciu na odev",
  cerrar: "✕ Zavrieť",
  seleccionado: "✓ Dizajn použitý:",
  cambiar: "Zmeniť dizajn",
  quitar: "✕ Odstrániť",
  tuDiseno: "Alebo nahraj vlastný dizajn",
  countSuffix: "exkluzívnych dizajnov",
};

const DE = {
  abrirGaleria: "🎨 RE₿EL Designs ansehen",
  tituloModal: "Exklusive RE₿EL™ Designs",
  subModal: "Klicke auf ein Design, um es auf das Kleidungsstück anzuwenden",
  cerrar: "✕ Schließen",
  seleccionado: "✓ Design angewendet:",
  cambiar: "Design ändern",
  quitar: "✕ Entfernen",
  tuDiseno: "Oder lade dein eigenes Design hoch",
  countSuffix: "exklusive Designs",
};

const ZH_CN = {
  abrirGaleria: "🎨 查看 RE₿EL 设计",
  tituloModal: "RE₿EL™ 独家设计",
  subModal: "点击设计即可应用到服装上",
  cerrar: "✕ 关闭",
  seleccionado: "✓ 已应用设计：",
  cambiar: "更换设计",
  quitar: "✕ 移除",
  tuDiseno: "或上传您自己的设计",
  countSuffix: "款独家设计",
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const getStudioDesignsI18n = (lang) => ALL[lang] || ALL.es;
